module.exports = __webpack_public_path__ + "static/media/slide_two.resized.312e2624.jpg";